import { DecisionMode } from './DecisionMode';
import { FlagshipConfig } from './FlagshipConfig';
export class DecisionApiConfig extends FlagshipConfig {
    constructor(param) {
        super({
            ...param,
            decisionMode: DecisionMode.DECISION_API
        });
    }
}
